class StaffId {
  constructor(private readonly _value: number = NaN) {
  }

  public equals(other: StaffId): boolean {
    return this._value === other.value;
  }

  get value() {
    return this._value;
  }
}

export default StaffId;
